export const calculateTableImageNumber = (hoseOrientation, instrumentCount) => {
	if (instrumentCount === 4) {
		return hoseOrientation === 'down' ? 1 : 3;
	}

	if (instrumentCount === 5) {
		return hoseOrientation === 'down' ? 5 : 6;
	}
	// instrumentCount === 6
	return hoseOrientation === 'down' ? 2 : 4;
};
